import { Component, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-alert-modal",
  templateUrl: "./alert-modal.component.html",
  styleUrls: ["./alert-modal.component.scss"],
})
export class AlertModalComponent {
  @Input() header!: string;
  @Input() message!: string;
  @Input() image?: string;

  constructor(private modalCtrl: ModalController) {}

  dismiss(data?: any) {
    this.modalCtrl.dismiss(data);
  }
}
